import type { ValueOptions } from '@mui/x-data-grid-pro';
import { isObject } from 'lodash';

export const getOptionValue = (option: ValueOptions) =>
  isObject(option) ? option.value : option;

export const getOptionLabel = (option: ValueOptions) =>
  isObject(option) ? option.label : option;
